import Button from "@rio-cloud/rio-uikit/Button";
import Dialog from "@rio-cloud/rio-uikit/Dialog";

export type ExportStage =
  | "maintenance"
  | "complementary"
  | "checkups"
  | "rioplans"
  | "writing"
  | "done"
  | "error";

interface IExportProgressDialogProps {
  show: boolean;
  stage: ExportStage;
  progress: number; // 0..100
  detail?: string;
  errorMessage?: string;
  onClose: () => void;
}

const STAGE_LABEL: Record<ExportStage, string> = {
  maintenance: "Carregando dados dos veículos",
  complementary: "Carregando grupos e status",
  checkups: "Carregando revisões",
  rioplans: "Carregando planos RIO e VolksTotal",
  writing: "Gerando arquivo",
  done: "Concluído",
  error: "Erro ao exportar",
};

const ExportProgressDialog = ({
  show,
  stage,
  progress,
  detail,
  errorMessage,
  onClose,
}: IExportProgressDialogProps) => {
  return (
    <Dialog
      show={show}
      bsSize="md"
      title="Exportando planilha"
      subtitle="Aguarde enquanto preparamos o arquivo para download."
      footer={
        <Button onClick={onClose} className="btn btn-primary" bsSize="lg">
          Fechar
        </Button>
      }
      body={
        <div className="w-full mx-auto bg-white dark:bg-neutral-900 rounded-lg p-6">
          {/* Texto da etapa atual */}
          <div className="text-size-16 text-color-darkest mb-3">
            {STAGE_LABEL[stage]}
            {detail ? ` — ${detail}` : ""}
          </div>

          {/* Barra de progresso */}
          <div className="h-[10px] w-full rounded progress overflow-hidden mb-2">
            <div
              className="h-full progress-bar progress-bar-striped progress-bar-primary transition-all duration-200"
              style={{ width: `${Math.max(0, Math.min(100, progress))}%` }}
            />
          </div>

          {/* Percentual */}
          <div className="text-right text-size-16 text-color-darkest mb-2">
            {Math.round(progress)}%
          </div>

          {/* Mensagem de erro */}
          {stage === "error" && (
            <div className="text-color-danger text-size-14">
              {errorMessage || "Algo deu errado ao gerar a planilha."}
            </div>
          )}
        </div>
      }
      onCloseValidation={() => {
        onClose();
        return true;
      }}
      showCloseButton
    />
  );
};

export default ExportProgressDialog;
